<template>
  <div class="donation">
    <PageBanner />
    <Breadcrumbs />

    <section class="content">
      <div class="container">

        <div class="slogan">
          「共享教育」是一個非牟利組織，利用多媒體致力推動免費教育。我們亦研究各項教學領域，並向各界倡議，以望提高協同效應。
        </div>

      </div>
    </section>
  </div>
</template>

<script>
  import PageBanner from "@/components/pageBanner.vue";
  import Breadcrumbs from "@/components/breadcrumbs.vue";
  export default {
    name: "Donation",
    components: {
      PageBanner,
      Breadcrumbs
    }
  };
</script>